<template>
  <v-container fluid class="product-description" v-if="tabs.length > 0">
    <!-- v-tabs per visibilità desktop -->
    <template v-if="!$vuetify.breakpoint.smAndDown">
      <v-container>
        <v-tabs v-model="selectedTab" fixed-tabs>
          <v-tab v-for="(tab, idx) in tabs" :key="idx" :class="tab.cssClass">
            <v-flex :class="idx + 1 < tabs.length ? 'divider' : ''">{{
              tab.title
            }}</v-flex>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="selectedTab">
          <v-tab-item
            v-for="(tab, index) in tabs"
            :key="index"
            :class="tab.cssClass"
          >
            <div
              v-for="(item, idx) in tab.items"
              :key="idx"
              class="pb-4"
              :class="item.cssClass"
            >
              <h4 class="text-uppercase" v-if="item.title">{{ item.title }}</h4>
              <div class="content" v-for="path in item.paths" :key="path.key">
                <component
                  :is="path.template || 'DefaultTpl'"
                  :content="path.content"
                  :append="path.append"
                  :width="path.width"
                />
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </template>

    <template v-else>
      <v-expansion-panels
        class="mb-2"
        accordion
        flat
        tile
        :focusable="selectedTab"
      >
        <v-expansion-panel
          v-for="tab in tabs"
          :key="tab.title"
          :class="tab.cssClass"
        >
          <v-expansion-panel-header class="pa-0">
            <h4 v-html="tab.title"></h4>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="mt-2">
            <div
              v-for="item in tab.items"
              :key="item.title"
              class="pb-4"
              :class="item.cssClass"
            >
              <h4 v-if="item.title">{{ item.title }}</h4>
              <div v-for="path in item.paths" :key="path.key">
                <component
                  :is="path.template || 'DefaultTpl'"
                  :content="path.content"
                  :append="path.append"
                />
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </v-container>
</template>

<script>
import {
  DefaultTpl,
  AnchorTpl,
  LabelsTpl,
  ItemsMapTpl,
  TableTpl,
  NameAndValueTpl,
  ValueTpl,
  WarningsTpl,
  ListTpl,
  MultipleAllergensMapTpl
} from "./templates";

import get from "lodash/get";
import kebabCase from "lodash/kebabCase";
//import tabsConfig from "/public/product/descriptionTabsConfig.json";
import tabsConfig from "/public/product/descriptionTabsConfig.json";
export default {
  name: "ProductDescription",
  /* eslint-disable vue/no-unused-components */
  components: {
    DefaultTpl,
    AnchorTpl,
    LabelsTpl,
    ItemsMapTpl,
    TableTpl,
    NameAndValueTpl,
    ValueTpl,
    WarningsTpl,
    ListTpl,
    MultipleAllergensMapTpl
  },
  data() {
    return {
      selectedTab: null,
      productDescriptionTabs: tabsConfig,
      showMetrologicE: false,
      showMetrologicEDrained: false,
      showMetrologicEPackaging: false,
      showMetrologicEDrainedPackaging: false,
      showMetrologicEIsPackage: false
    };
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    productMetadata: {
      type: Object
    },
    ingredientList: {
      type: Object
    }
  },
  computed: {
    tabs() {
      let tabs = [];
      let multipack =
        this.productMetadata.product_description.MULTIPACK_FLAG == "S";
      this.productDescriptionTabs.forEach(tabMeta => {
        let items = [];
        tabMeta.items.forEach(parMeta => {
          let paths = [];
          parMeta.paths.forEach(pathMeta => {
            let content = get(this.product, pathMeta.data || pathMeta);
            let append = pathMeta.append;
            // check if content is empty
            if (content && content !== "<p></p>") {
              // check if table has empty cells
              if (pathMeta.template === "TableTpl") {
                let cells = JSON.parse(content).cells;
                console.log(cells);
                let hasContent = cells.find(c => {
                  return c !== null;
                });
                if (!hasContent) {
                  return;
                }
              }
              if (pathMeta.template === "ValueTpl") {
                let value = JSON.parse(content).value;
                if (!value) {
                  return;
                }
              }

              paths.push({
                key: pathMeta.data || pathMeta,
                content: content,
                template: pathMeta.template,
                append: append
              });
            }
          });
          if (paths.length > 0) {
            items.push({
              title: parMeta.title,
              paths: paths,
              cssClass: get(parMeta, "cssClass", kebabCase(parMeta.title))
            });
          }
        });
        if (items.length > 0) {
          tabs.push({
            title: tabMeta.title,
            items: items,
            cssClass: get(tabMeta, "cssClass", kebabCase(tabMeta.title))
          });
        }
      });
      let descriptionTab = tabs.find(t => {
        return t.title === "Descrizione";
      });
      if (descriptionTab) {
        const estimatedSymbol =
          '<span class="ml-1" style="color: #333333;font-size: 20px;">℮</span>';

        descriptionTab.items.find(d => {
          if (d.title === "Quantità:") {
            var custom_paths = [];
            // If METROLOGIC_E_DESCRIPTION exists, return it, else do the evaluation for metrologic_e and NET_WEIGHT

            d.paths.find(e => {
              if (
                e.key === "metaData.product_description.METROLOGIC_E" &&
                (e.content.toLowerCase() === "yes" ||
                  e.content.toLowerCase() === "si" ||
                  e.content.toLowerCase() === "sì")
              ) {
                this.showMetrologicE = true;
                return;
              }
            });
            d.paths.find(e => {
              if (
                e.key ===
                  "metaData.product_description..METROLOGIC_E_IS_PACKAGE" &&
                (e.content.toLowerCase() === "yes" ||
                  e.content.toLowerCase() === "si" ||
                  e.content.toLowerCase() === "sì")
              ) {
                this.showMetrologicEIsPackage = true;
                return;
              }
            });
            d.paths.find(e => {
              if (
                e.key ===
                  "metaData.product_description.METROLOGIC_E_IS_PACKAGE" &&
                (e.content.toLowerCase() === "yes" ||
                  e.content.toLowerCase() === "si" ||
                  e.content.toLowerCase() === "sì")
              ) {
                this.showMetrologicEIsPackage = true;
                return;
              }
            });

            d.paths.find(e => {
              if (
                e.key ===
                  "metaData.product_description.METROLOGIC_E_PACKAGING" &&
                (e.content.toLowerCase() === "yes" ||
                  e.content.toLowerCase() === "si" ||
                  e.content.toLowerCase() === "sì")
              ) {
                this.showMetrologicEPackaging = true;
                return;
              }
            });

            d.paths = d.paths.filter(function(el) {
              return el.key !== "metaData.product_description.METROLOGIC_E";
            });

            d.paths = d.paths.filter(function(el) {
              return (
                el.key !== "metaData.product_description.METROLOGIC_E_PACKAGING"
              );
            });

            d.paths.find(p => {
              if (p.key === "metaData.product_description.AVARAGE_WEIGHT") {
                custom_paths.push(p);
                d.paths = custom_paths;
                return;
              }
            });
            if (
              this.showMetrologicEPackaging ||
              (this.showMetrologicE && this.showMetrologicEIsPackage)
            ) {
              d.paths.find(p => {
                const index = p.content.lastIndexOf(")");
                if (index !== -1) {
                  p.content =
                    p.content.slice(0, index) +
                    estimatedSymbol +
                    p.content.slice(index);
                }
              });
            } else if (this.showMetrologicE) {
              d.paths.find(p => {
                p.content = `${p.content}${estimatedSymbol}`;
              });
            }
          }

          const showPesoSgocciolato = descriptionTab?.items?.some(
            item =>
              item.title === "Peso sgocciolato:" &&
              item.paths.some(
                path =>
                  path.key ===
                    "metaData.product_description.NET_DRAINED_WEIGHT" &&
                  path.content &&
                  path.content.trim() !== ""
              )
          );
          console.log(":::::::: show peso field :::::::", showPesoSgocciolato);

          if (showPesoSgocciolato) {
            if (d.title === "Peso sgocciolato:") {
              var custom_paths_drained = [];
              d.paths.find(e => {
                if (
                  e.key ===
                    "metaData.product_description.METROLOGIC_E_DRAINED" &&
                  (e.content.toLowerCase() === "yes" ||
                    e.content.toLowerCase() === "si" ||
                    e.content.toLowerCase() === "sì")
                ) {
                  this.showMetrologicEDrained = true;
                  return;
                }
              });
              d.paths.find(e => {
                if (
                  e.key ===
                    "metaData.product_description.METROLOGIC_E_IS_PACKAGE" &&
                  (e.content.toLowerCase() === "yes" ||
                    e.content.toLowerCase() === "si" ||
                    e.content.toLowerCase() === "sì")
                ) {
                  this.showMetrologicEIsPackage = true;
                  return;
                }
              });
              d.paths.find(e => {
                if (
                  e.key ===
                    "metaData.product_description.METROLOGIC_E_DRAINED_PACKAGING" &&
                  (e.content.toLowerCase() === "yes" ||
                    e.content.toLowerCase() === "si" ||
                    e.content.toLowerCase() === "sì")
                ) {
                  this.showMetrologicEDrainedPackaging = true;
                  return;
                }
              });

              d.paths = d.paths.filter(function(el) {
                return (
                  el.key !== "metaData.product_description.METROLOGIC_E_DRAINED"
                );
              });

              d.paths = d.paths.filter(function(el) {
                return (
                  el.key !==
                  "metaData.product_description.METROLOGIC_E_DRAINED_PACKAGING"
                );
              });

              d.paths.find(p => {
                if (
                  p.key === "metaData.product_description.NET_DRAINED_WEIGHT"
                ) {
                  custom_paths_drained.push(p);
                  d.paths = custom_paths_drained;
                  return;
                }
              });
              if (
                this.showMetrologicEDrainedPackaging ||
                (this.showMetrologicEDrained && this.showMetrologicEIsPackage)
              ) {
                d.paths.find(p => {
                  const index = p.content.lastIndexOf(")");

                  if (index !== -1) {
                    p.content =
                      p.content.slice(0, index) +
                      estimatedSymbol +
                      p.content.slice(index);
                  }
                });
              } else if (
                this.showMetrologicEDrained &&
                !this.showMetrologicEDrainedPackaging
              ) {
                d.paths.find(p => {
                  p.content = p.content + estimatedSymbol;
                });
              }
            }
          } else {
            console.log(":::: console arrayyyy", descriptionTab.items);
            descriptionTab.items = descriptionTab.items.filter(
              item => item.title !== "Peso sgocciolato:"
            );
            console.log(":::: after arrayyyy", descriptionTab.items);
          }
        });
      }

      // additional text at Ingredients tab end
      let ingredientsTab = tabs.find(t => {
        return t.title === "Ingredienti";
      });
      if (ingredientsTab) {
        var _this = this;
        _this.foundAllergens = false;
        _this.multiAllergens = false;
        _this.multiAllergens = false;
        var staticDisclaimer = {
          title: "",
          paths: [
            {
              key: "metaData.product_description.STATIC_DISCLAIMER",
              content: this.$t("productDescription.staticDisclaimer")
            }
          ]
        };
        // ingredientsTab.items.push({
        //   paths: [
        //     { content: this.$t("productDescription.ingredientsAdditionalInfo") }
        //   ]
        // });
        ingredientsTab.items.push(staticDisclaimer);
        ingredientsTab.items.find(ing => {
          if (ing.title == "Allergeni:") {
            ing.paths.filter(function(el) {
              if (
                el.key === "metaData.product_description.ALLERGENS_MULT" ||
                el.key === "metaData.product_description.ALLERGENS" ||
                el.key === "metaData.product_description.ALLERGENS_ELEMENTS"
              ) {
                if (el.key === "metaData.product_description.ALLERGENS_MULT") {
                  JSON.parse(el.content).find(o => {
                    if (
                      !o["items-map"].allergens.options ||
                      (o["items-map"].allergens.options.length == 0 &&
                        !_this.foundAllergens)
                    ) {
                      _this.hideAllergens = true;
                      _this.multiAllergens = false;
                    } else {
                      _this.multiAllergens = true;
                      _this.foundAllergens = true;
                      _this.hideAllergens = false;
                    }
                  });
                } else if (
                  el.key === "metaData.product_description.ALLERGENS" &&
                  !_this.foundAllergens
                ) {
                  _this.foundAllergens = true;
                  _this.foundOriginalAllergens = true;
                  _this.hideAllergens = false;
                } else {
                  if (
                    el.key === "metaData.product_description.ALLERGENS_ELEMENTS"
                  ) {
                    _this.foundAllergens = true;
                    _this.foundAllergensElements = true;
                    _this.hideAllergens = false;

                    var ingredientsFound = [];

                    var elements = JSON.parse(el.content);

                    for (var i = 0; i < elements.length; i++) {
                      elements[i]["items-map"].allergens.options.forEach(al => {
                        ingredientsFound.push(al);
                      });
                    }

                    const key = "label";
                    ingredientsFound = [
                      ...new Map(
                        ingredientsFound.map(item => [item[key], item])
                      ).values()
                    ];
                    if (ingredientsFound.length > 0)
                      el.content = JSON.stringify(ingredientsFound);
                  }
                }
              }
            });
          }

          if (ing.title == "Url etichetta elettronica") {
            ing.paths.filter(function(el) {
              if (
                el.key === "metaData.product_description.DIGITAL_LABEL" &&
                el.content
              ) {
                console.log("content", el.content);
              }
            });
          }
          if (ing.title == "Ingredienti:") {
            ing.paths.filter(function(el) {
              if (el.key === "metaData.product_description.INGREDIENTS_HTML") {
                if (el.content.length == 0 || el.content == "<p></p>") {
                  _this.hideIngredients = true;
                } else {
                  _this.hideIngredients = false;
                }
              }
            });
          }
        });

        ingredientsTab.items.find(x => {
          if (x.allergensAdditionalText) {
            this.allergensAdditionalText = true;
          }
          if (this.hideAllergens) {
            x.paths = x.paths.filter(function(el) {
              return (
                el.key !== "metaData.product_description.ALLERGENS_MULT" &&
                el.key !== "metaData.product_description.ALLERGENS" &&
                el.key != "metadata.product_description.ALLERGENS_ELEMENTS"
              );
            });
          } else {
            if (
              _this.multiAllergens &&
              !_this.foundOriginalAllergens &&
              !_this.foundAllergensElements
            ) {
              x.paths = x.paths.filter(function(el) {
                return (
                  el.key !== "metaData.product_description.ALLERGENS" &&
                  el.key !== "metaData.product_description.ALLERGENS_ELEMENTS"
                );
              });
            } else if (
              _this.foundOriginalAllergens &&
              !_this.multiAllergens &&
              !_this.foundAllergensElements
            ) {
              x.paths = x.paths.filter(function(el) {
                return (
                  el.key !== "metaData.product_description.ALLERGENS_MULT" &&
                  el.key !== "metaData.product_description.ALLERGENS_ELEMENTS"
                );
              });
            } else if (_this.foundAllergensElements) {
              x.paths = x.paths.filter(function(el) {
                return (
                  el.key !== "metaData.product_description.ALLERGENS_MULT" &&
                  el.key !== "metaData.product_description.ALLERGENS"
                );
              });
            } else {
              return true;
            }
          }
        });
        ingredientsTab.items = ingredientsTab.items.filter(el => {
          if (this.hideAllergens) {
            return el.title !== "Allergeni:";
          } else {
            return true;
          }
        });
      }

      if (multipack) {
        let ingredientsTab = tabs.find(t => {
          return t.title === "Ingredienti";
        });
        if (ingredientsTab) {
          let multipackIngredients = JSON.parse(
            this.productMetadata.product_description.MULTIPACK_INGREDIENTS
          );
          ingredientsTab.items = [];

          for (let i = 0; i < multipackIngredients.length; i++) {
            console.log("BBB", multipackIngredients);
            if (multipackIngredients[i].description?.value) {
              ingredientsTab.items.push({
                cssClass: "ingredients",
                paths: [
                  {
                    content: multipackIngredients[i].description.value
                  }
                ]
              });
            }

            if (multipackIngredients[i].ingredientsHtml?.value) {
              ingredientsTab.items.push({
                title: "Ingredienti:",
                cssClass: "ingredients",
                paths: [
                  {
                    content: multipackIngredients[
                      i
                    ].ingredientsHtml.value.replace(/<\/?p[^>]*>/g, "")
                  }
                ]
              });
            }

            if (multipackIngredients[i].ingredients?.elements?.length) {
              let allergens = [];
              multipackIngredients[i].ingredients.elements.forEach(element => {
                element["items-map"].allergens.options.forEach(option => {
                  if (
                    !allergens.map(a => a.key).find(key => key == option.key)
                  ) {
                    allergens.push(option);
                  }
                });
              });

              ingredientsTab.items.push({
                title: "Allergeni:",
                paths: [
                  {
                    content: allergens.map(a => a.label).join(", ")
                  }
                ]
              });
            }

            if (multipackIngredients[i].crossContamination?.options?.length) {
              ingredientsTab.items.push({
                title: "Può contenere tracce di:",
                paths: [
                  {
                    content: multipackIngredients[i].crossContamination.options
                      .map(option => option.label)
                      .join(", ")
                  }
                ]
              });
            }

            if (multipackIngredients[i].primaryIngredientOrigin?.value) {
              ingredientsTab.items.push({
                title:
                  multipackIngredients[i].primaryIngredientOrigin.name + ":",
                paths: [
                  {
                    content:
                      multipackIngredients[i].primaryIngredientOrigin.value
                  }
                ]
              });
            }

            if (multipackIngredients[i].ingredientsAdditionalText?.value) {
              ingredientsTab.items.push({
                title: "Informazioni aggiuntive:",
                paths: [
                  {
                    content:
                      multipackIngredients[i].ingredientsAdditionalText.value
                  }
                ]
              });
            }

            ingredientsTab.items.push({}, {});
          }

          if (
            this.productMetadata.product_description.INGREDIENTS_ADDITIONAL_TEXT
          ) {
            ingredientsTab.items.push({
              title: "Informazioni aggiuntive:",
              paths: [
                {
                  content: this.productMetadata.product_description
                    .INGREDIENTS_ADDITIONAL_TEXT
                }
              ]
            });
          }

          ingredientsTab.items.push(staticDisclaimer);
        }

        let nutritionalValuesTab = tabs.find(n => {
          return n.title === "Valori nutrizionali";
        });
        if (nutritionalValuesTab) {
          let multipackNutrition = JSON.parse(
            this.productMetadata.product_description.MULTIPACK_NUTRITION
          );
          nutritionalValuesTab.items = [];

          for (let i = 0; i < multipackNutrition.length; i++) {
            if (multipackNutrition[i].nutrition) {
              nutritionalValuesTab.items.push({
                title: multipackNutrition[i].nutrition.name + ":",
                cssClass: "nutritional-info",
                paths: [
                  {
                    content: multipackNutrition[i].description?.value
                  },
                  {
                    content: JSON.stringify(multipackNutrition[i].nutrition),
                    template: "TableTpl",
                    width: "fit-content"
                  }
                ]
              });
            }

            if (multipackNutrition[i].additionalNutrition?.rows?.length) {
              nutritionalValuesTab.items.push({
                title: multipackNutrition[i].additionalNutrition?.name + ":",
                cssClass: "nutritional-info",
                paths: [
                  {
                    content: JSON.stringify(
                      multipackNutrition[i].additionalNutrition
                    ),
                    template: "TableTpl",
                    width: "fit-content"
                  }
                ]
              });
            }

            if (multipackNutrition[i].ar?.value) {
              nutritionalValuesTab.items.push({
                title: multipackNutrition[i].ar?.name + ":",
                cssClass: "nutritional-info",
                paths: [
                  {
                    content: multipackNutrition[i].ar.value
                  }
                ]
              });
            }

            if (multipackNutrition[i].portionNumber?.value) {
              nutritionalValuesTab.items.push({
                title: multipackNutrition[i].portionNumber?.name + ":",
                cssClass: "nutritional-info",
                paths: [
                  {
                    content: multipackNutrition[i].portionNumber.value
                  }
                ]
              });
            }

            if (multipackNutrition[i].value?.value) {
              nutritionalValuesTab.items.push({
                title: multipackNutrition[i].value.name + ":",
                cssClass: "nutritional-info",
                paths: [
                  {
                    content: multipackNutrition[i].value.value
                  }
                ]
              });
            }

            if (multipackNutrition[i].nutritionalDeclaration?.value) {
              nutritionalValuesTab.items.push({
                title: multipackNutrition[i].nutritionalDeclaration?.name + ":",
                cssClass: "nutritional-info",
                paths: [
                  {
                    content: multipackNutrition[i].nutritionalDeclaration.value
                  }
                ]
              });
            }

            if (multipackNutrition[i].additionalInformation?.value) {
              nutritionalValuesTab.items.push({
                title: multipackNutrition[i].additionalInformation?.name + ":",
                cssClass: "nutritional-info",
                paths: [
                  {
                    content: multipackNutrition[i].additionalInformation.value
                  }
                ]
              });
            }

            if (i < multipackNutrition.length - 1) {
              nutritionalValuesTab.items.push({}, {});
            }
          }
        }
      }

      return tabs;
    }
  }
};
</script>
